/**
 * Server fetch constants matching Flutter app configuration
 */
export const SERVER_FETCH_CONSTANTS = {
    // Pagination
    DEFAULT_LIMIT: 9,
    MAX_LIMIT: 50,

    SYNC_PAGINATION_LIMIT: 100,
    MAX_SYNC_PAGINATION_LIMIT: 1000,

    SEARCH_PAGINATION_LIMIT: 9,
    SEARCH_USERS_PAGINATION_LIMIT: 6,

    COMMENT_CHILDREN_PAGINATION: 3,

    // Notifications list page size + collapse window (Flutter: lib/domain/constants/app_constants.dart:7).
    NOTIFICATIONS_LIST_PAGINATION: 4,

    // Shared 20-page pagination token reused everywhere a message/comment list
    // pages: inbox chat-node lists, chat message details, comments, roadmap
    // comments, community-wall messages, and live-streaming messages
    // (Flutter: lib/domain/constants/app_constants.dart:11 `messagesListPagination = 20`).
    MESSAGES_LIST_PAGINATION: 20,

    // Firestore `in` / `array-contains-any` operators accept at most 10 values.
    FIRESTORE_WHERE_IN_MAX_VALUES: 10,
} as const;

export type ServerFetchConstants = typeof SERVER_FETCH_CONSTANTS;
